<template>
    <v-alert
        v-if="value"
        :value="value"
        v-bind="{type,dismissible,outlined,text,dense,prominent,icon,border,color,elevation}"
        >
        <strong>{{message}}</strong>
        <ul v-if="errors" >
            <li v-for="(err,field) in errors">
                <strong>{{field}}</strong>
                <ul>
                    <li v-for="e in err">{{e}}</li>
                </ul>
            </li>
        </ul>
        <slot></slot>
    </v-alert>
</template>
<script>
export default {
    props: {
        value:{},
        type:{default:'error'},
        dismissible:{type:Boolean,default:false,},
        outlined:{type:Boolean,default:false,},
        text:{type:Boolean,default:false,},
        dense:{type:Boolean,default:false,},
        prominent:{type:Boolean,default:false,},
        icon:{},
        border:{},
        color:{},
        elevation:{},
    },
    data() {
        return {}
    },
    mounted() {
    },
    computed: {
        message(){
            return (this.value && this.value.response && this.value.response.data && this.value.response.data.message)
                    || this.value;
        },
        errors(){return this.value && this.value.response && this.value.response.data && this.value.response.data.errors; },
    },
    methods: {},

    components: {},
    filters: {}
}
</script>
